var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hospital") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 3.4375v.5h1.25v.25h-1.25v1.25h-.25v-1.25h-1.25v-.25h1.25v-1.25h.25v.75Zm5 0v.5h1c.7577 0 1.375.61727 1.375 1.375V15.5H9.75v-2.5625h-3.5V15.5H.5V5.3125c0-.75773.61727-1.375 1.375-1.375h1V1.875C2.875 1.11727 3.49227.5 4.25.5h7.5c.7577 0 1.375.61727 1.375 1.375v1.5625ZM2.375 15.25h.5V4.1875h-1c-.62077 0-1.125.50423-1.125 1.125V15.25h1.625Zm10 0h.5V1.875c0-.62077-.5042-1.125-1.125-1.125h-7.5c-.62077 0-1.125.50423-1.125 1.125V15.25H6v-2.5625h4V15.25h2.375Zm2.375 0h.5V5.3125c0-.62077-.5042-1.125-1.125-1.125h-1V15.25h1.625Zm-6.875-4.8125v-.25h.25v.25h-.25Zm-2.5-2.5v-.25h.25v.25h-.25Zm0 2.5v-.25h.25v.25h-.25Zm5-2.5v-.25h.25v.25h-.25Zm-2.5 0v-.25h.25v.25h-.25Zm2.5 2.5v-.25h.25v.25h-.25Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.ee5300a8.svg";
export { ForwardRef as ReactComponent };